// This file is auto-generated by @hey-api/openapi-ts

import type { GetMeApiV3MeGetResponse } from './types.gen';

const intervalSchemaResponseTransformer = (data: any) => {
    if (data.start) {
        data.start = new Date(data.start);
    }
    if (data.end) {
        data.end = new Date(data.end);
    }
    return data;
};

const meResponseSchemaResponseTransformer = (data: any) => {
    data.current_org_period = intervalSchemaResponseTransformer(data.current_org_period);
    return data;
};

export const getMeApiV3MeGetResponseTransformer = async (data: any): Promise<GetMeApiV3MeGetResponse> => {
    data = meResponseSchemaResponseTransformer(data);
    return data;
};
